__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => (typeof console !== "undefined" && console.warn && console.warn(msg));
	var uniqueName = "@marah.cloud/information";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@tomfxs/pukeko", "1.2.12", () => (Promise.all([__webpack_require__.e(699), __webpack_require__.e(164), __webpack_require__.e(950), __webpack_require__.e(181)]).then(() => (() => (__webpack_require__(58699))))));
			register("i18next", "21.6.5", () => (Promise.all([__webpack_require__.e(92), __webpack_require__.e(38)]).then(() => (() => (__webpack_require__(62092))))));
			register("react-dnd-touch-backend", "14.1.1", () => (__webpack_require__.e(1).then(() => (() => (__webpack_require__(22001))))));
			register("react-dnd", "14.0.5", () => (Promise.all([__webpack_require__.e(963), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(24963))))));
			register("react-dom", "17.0.2", () => (Promise.all([__webpack_require__.e(935), __webpack_require__.e(950)]).then(() => (() => (__webpack_require__(73935))))));
			register("react-i18next", "11.15.3", () => (Promise.all([__webpack_require__.e(950), __webpack_require__.e(430)]).then(() => (() => (__webpack_require__(41430))))));
			register("react-router-dom", "6.2.1", () => (Promise.all([__webpack_require__.e(68), __webpack_require__.e(950), __webpack_require__.e(462)]).then(() => (() => (__webpack_require__(26068))))));
			register("react", "17.0.2", () => (__webpack_require__.e(294).then(() => (() => (__webpack_require__(67294))))));
			initExternal(39974);
			initExternal(23968);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};